import { render, staticRenderFns } from "./CenterCenter.vue?vue&type=template&id=40425a98&scoped=true"
import script from "./CenterCenter.vue?vue&type=script&lang=ts"
export * from "./CenterCenter.vue?vue&type=script&lang=ts"
import style0 from "./CenterCenter.vue?vue&type=style&index=0&id=40425a98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40425a98",
  null
  
)

export default component.exports